// Generated by Claude Code
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { FeatureGuard } from '#components/tools/feature-guard.tsx'
import { PurchaseOrdersUnavailable } from '#components/entities/purchase-orders/purchase-orders-unavailable.tsx'
import { PurchaseOrdersPage } from '#components/entities/purchase-orders/list/purchase-orders-page.tsx'
import { PermissionService } from '#core/entities/auth/roles/Permission.ts'

export const Route = createFileRoute('/_app/$companyId/purchase-orders')({
  component: RouteComponent,
  staticData: { title: 'Purchase Orders', appShell: true },
})

function RouteComponent() {
  const { t } = useTranslation('purchase-orders')
  
  return (
    <FeatureGuard
      service={PermissionService.PURCHASE_ORDERS}
      title={t('title')}
      fallback={(denial) => <PurchaseOrdersUnavailable denial={denial} />}
    >
      <PurchaseOrdersPage />
    </FeatureGuard>
  )
}
